module.exports = {"phoneNumber":{"minLengthMap":{"DK":11,"GL":8},"maxLengthMap":{"DK":11,"GL":22}}}